import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Vehicle } from 'src/app/core/models/vehicle';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrl: './confirm.component.css'
})
export class ConfirmComponent {
  @Input() visible = false;
  @Input() vehicle: Vehicle | null = null;
  @Input() icon = 'pi pi-car'; // Ícone da categoria

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onConfirm = new EventEmitter<void>();

  close() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  confirm() {
    this.onConfirm.emit();
    this.close();
  }
}
